module.exports = __webpack_public_path__ + "static/media/mysqool.eff3485c.png";